var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-camera.f66e34be.png","uri@2x": __webpack_public_path__ + "icon-camera.8eb268cf.png","uri@3x": __webpack_public_path__ + "icon-camera.f79ddcc7.png",
    width: 44,
    height: 44
});